// src/admin/components/TopPostsWidget.jsx

import { useTheme } from "../../context/ThemeContext";

export default function TopPostsWidget({ posts = [] }) {

  const { isDark } = useTheme();

  return (
    <div
      className={`
        rounded-3xl
        border
        p-6
        ${
          isDark
            ? "bg-white/5 border-white/10"
            : "bg-white border-gray-200"
        }
      `}
    >
      <h2 className="text-xl font-semibold mb-6">
        Top Performing Posts
      </h2>

      <div className="space-y-5">

        {posts.map((post, index) => (

          <div
            key={post.id}
            className="flex items-center justify-between"
          >
            <div>

              <p className="font-medium">
                #{index + 1} {post.title}
              </p>

              <p
                className={`
                  text-sm
                  ${
                    isDark
                      ? "text-gray-400"
                      : "text-gray-500"
                  }
                `}
              >
                {post.views.toLocaleString()} views
              </p>

            </div>

          </div>

        ))}

      </div>
    </div>
  );
}